export function replace(array, newValue, condition, addIfNotFind = false) {
    const i = array.findIndex(condition);
    const newArray = [...array];
    if (i < 0) {
        if (addIfNotFind) {
            newArray.push(newValue);
        }
    }
    else {
        newArray[i] = newValue;
    }
    return newArray;
}
//# sourceMappingURL=replace.js.map